import sliceCreator from '../../index.jsx';
import {FORGOT_PASSWORD} from '../../../constants/index.jsx';
const _forgotPasswordAction = sliceCreator('FORGOT_PASSWORD', FORGOT_PASSWORD, 'post');

const { asyncAction: forgotPasswordAction, reducer, clearData: clearForgotPasswordAction } = _forgotPasswordAction;

export default reducer;

export {
    forgotPasswordAction,
    clearForgotPasswordAction
}